import { z } from 'zod';

/**
 * Lookup rapidi di destinatari (picker del Feed, condivisioni File Manager):
 * rotte top-level del `protectedRouter` (`packages/backend/src/routes/index.ts`)
 * con envelope `{ success, data: [...] }`.
 *
 *  - `GET /users/search?search=&limit=` → `data: DirectoryUserLookup[]`
 *  - `GET /workgroups?search=&limit=`   → `data: WorkgroupLookup[]`
 *  - `GET /departments?search=&limit=`  → `data: DepartmentLookup[]`
 */

export const directoryUserLookupSchema = z
  .object({
    id: z.string(),
    first_name: z.string().nullable(),
    last_name: z.string().nullable(),
    email: z.string(),
    mobile: z.string().nullable().optional(),
    role: z.string().optional(),
    status: z.string().optional(),
  })
  .passthrough();
export type DirectoryUserLookup = z.infer<typeof directoryUserLookupSchema>;

export const workgroupLookupSchema = z
  .object({
    id: z.string(),
    name: z.string(),
    description: z.string().nullable().optional(),
    member_count: z.union([z.string(), z.number()]).optional(),
  })
  .passthrough();
export type WorkgroupLookup = z.infer<typeof workgroupLookupSchema>;

export const departmentLookupSchema = z
  .object({
    id: z.string(),
    name: z.string(),
    description: z.string().nullable().optional(),
  })
  .passthrough();
export type DepartmentLookup = z.infer<typeof departmentLookupSchema>;
